import _toConsumableArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "./index.css";
import { jsx, jsxs } from 'react/jsx-runtime';
import { Icon } from '@design-system/icon';
import { Section } from '@design-system/section';
import { Typography } from '@design-system/typography';
import { ScreenRecognitionContext } from '@phx-husky/screen-recognition';
import classNames from 'classnames';
import { forwardRef, useState, useContext, useEffect } from 'react';
var InfoBarAction;
(function (InfoBarAction) {
  InfoBarAction["PAUSE"] = "pause";
  InfoBarAction["PLAY"] = "play";
  InfoBarAction["NEXT"] = "next";
  InfoBarAction["PREVIOUS"] = "previous";
})(InfoBarAction || (InfoBarAction = {}));
var InfoBar = forwardRef(function (_ref, ref) {
  var className = _ref.className,
    messages = _ref.messages,
    ariaLabels = _ref.ariaLabels,
    _ref$soloMode = _ref.soloMode,
    soloMode = _ref$soloMode === void 0 ? false : _ref$soloMode,
    _ref$intervalTime = _ref.intervalTime,
    intervalTime = _ref$intervalTime === void 0 ? 4 : _ref$intervalTime;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeElementIndex = _useState2[0],
    setActiveElementIndex = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isPaused = _useState4[0],
    setIsPaused = _useState4[1];
  var _useContext = useContext(ScreenRecognitionContext),
    isMobile = _useContext.isMobile;
  var changeText = function changeText(action) {
    var messagesKeys = _toConsumableArray(messages.keys());
    var lastElementIndex = messagesKeys[messages.length - 1];
    switch (action) {
      case InfoBarAction.PAUSE:
        setIsPaused(true);
        break;
      case InfoBarAction.PLAY:
        setIsPaused(false);
        break;
      case InfoBarAction.NEXT:
        setActiveElementIndex(function (prev) {
          var _a;
          return (_a = messagesKeys[prev + 1]) !== null && _a !== void 0 ? _a : 0;
        });
        break;
      case InfoBarAction.PREVIOUS:
        setActiveElementIndex(function (prev) {
          var _a;
          return (_a = messagesKeys[prev - 1]) !== null && _a !== void 0 ? _a : lastElementIndex;
        });
        break;
    }
  };
  var handlePlay = function handlePlay() {
    changeText(InfoBarAction.PLAY);
  };
  useEffect(function () {
    if (isPaused || messages.length <= 0 || soloMode) return undefined;
    var interval = setInterval(function () {
      changeText(InfoBarAction.NEXT);
    }, intervalTime * 1000);
    return function () {
      clearInterval(interval);
    };
  }, [isPaused]);
  var handleNextText = function handleNextText() {
    changeText(InfoBarAction.NEXT);
  };
  var handlePreviousText = function handlePreviousText() {
    changeText(InfoBarAction.PREVIOUS);
  };
  var handlePause = function handlePause() {
    changeText(InfoBarAction.PAUSE);
  };
  return jsx(Section, Object.assign({
    "data-testid": "info-bar",
    ref: ref,
    element: "aside",
    removeAllSpacing: true,
    className: classNames('cds-info-bar', className)
  }, {
    children: jsxs("div", Object.assign({
      className: "cds-info-bar__container"
    }, {
      children: [isMobile && !soloMode && jsx("button", Object.assign({
        type: "button",
        "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.arrowLeft,
        onClick: handlePreviousText,
        id: "btn-info-bar-prev"
      }, {
        children: jsx(Icon, {
          icon: "arrowLeft"
        })
      })), jsx(Typography, {
        variant: "body",
        size: isMobile ? 'xs' : 's',
        weight: "medium",
        className: "cds-info-bar__message",
        content: messages[activeElementIndex].text
      }), isMobile && !soloMode && jsx("button", Object.assign({
        type: "button",
        "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.arrowRight,
        onClick: handleNextText,
        id: "btn-info-bar-next"
      }, {
        children: jsx(Icon, {
          icon: "arrowRight"
        })
      })), !isMobile && !soloMode && jsxs("div", Object.assign({
        className: "cds-info-bar__action-icons"
      }, {
        children: [jsx("button", Object.assign({
          type: "button",
          "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.arrowLeft,
          onClick: handlePreviousText,
          id: "btn-info-bar-prev"
        }, {
          children: jsx(Icon, {
            icon: "arrowLeft"
          })
        })), isPaused ? jsx("button", Object.assign({
          type: "button",
          "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.play,
          onClick: handlePlay,
          id: "btn-play"
        }, {
          children: jsx(Icon, {
            icon: "play"
          })
        })) : jsx("button", Object.assign({
          type: "button",
          "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.pause,
          onClick: handlePause,
          id: "btn-pause"
        }, {
          children: jsx(Icon, {
            icon: "pause"
          })
        })), jsx("button", Object.assign({
          type: "button",
          "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.arrowRight,
          onClick: handleNextText,
          id: "btn-info-bar-next"
        }, {
          children: jsx(Icon, {
            icon: "arrowRight"
          })
        }))]
      }))]
    }))
  }));
});
export { InfoBar };